import { READIUM_INITIALIZED } from './actionTypes';

export const readiumInitialized = (readiumClass) => {
  return { type: READIUM_INITIALIZED, readiumClass };
};
